import { FeedbackBanner } from "@/core/components/feedback-banner";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import type {
  PayrollStatementNotificationDelivery,
  PayrollStatementNotificationRecipient,
} from "./types";
import { getNotificationReasonLabel } from "./utils";

export const SendFailuresBanner = ({
  deliveries,
  recipients,
}: {
  deliveries: PayrollStatementNotificationDelivery[];
  recipients: PayrollStatementNotificationRecipient[];
}) => {
  if (deliveries.length === 0) return null;

  const recipientNames = new Map(
    recipients.map((recipient) => [recipient.technician_id, recipient.name]),
  );

  return (
    <FeedbackBanner variant="error">
      <Typography variant="bodyW3">Some PayPacks couldn't be sent.</Typography>
      <Stack gap="xs">
        {deliveries.map((delivery, index) => {
          const key =
            delivery.delivery_id ??
            delivery.id ??
            `${delivery.technician_id ?? "unknown"}-${index}`;
          const recipientName = delivery.technician_id
            ? recipientNames.get(delivery.technician_id)
            : null;

          return (
            <Typography key={key} variant="bodyW2" textColor="secondary">
              {recipientName ?? delivery.recipient_email ?? "Unknown recipient"}
              : {getNotificationReasonLabel(delivery.error) ?? "Failed"}
            </Typography>
          );
        })}
      </Stack>
    </FeedbackBanner>
  );
};
